/**
 * ExtranetAwaitingApproval — Fase 4 Extranet KB
 * Tela vista pelo usuário externo enquanto is_active=false.
 */
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';
import { ExtranetAuthProvider, useExtranetAuth } from '@/hooks/useExtranetAuth';

function AwaitingInner() {
  const { signOut, externalUser, tenant } = useExtranetAuth();
  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <Helmet>
        <title>Aguardando aprovação</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Card className="w-full max-w-md p-6 space-y-4 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-yellow-500/10 flex items-center justify-center">
          <Clock className="h-6 w-6 text-yellow-600" />
        </div>
        <div className="space-y-1">
          <h1 className="text-lg font-semibold">Cadastro em análise</h1>
          <p className="text-sm text-muted-foreground">
            {externalUser?.display_name ? `Olá, ${externalUser.display_name}. ` : ''}
            Seu acesso ao portal {tenant?.name ? `da ${tenant.name}` : ''} está aguardando aprovação
            do administrador. Você receberá uma notificação assim que for liberado.
          </p>
        </div>
        <Button variant="outline" onClick={signOut} className="w-full">
          Sair
        </Button>
      </Card>
    </div>
  );
}

export default function ExtranetAwaitingApproval() {
  const { tenantSlug = '' } = useParams<{ tenantSlug: string }>();
  return (
    <ExtranetAuthProvider tenantSlug={tenantSlug}>
      <AwaitingInner />
    </ExtranetAuthProvider>
  );
}
